import { render, staticRenderFns } from "./initImmagineSfondo.vue?vue&type=template&id=5fd8f28b&"
import script from "./initImmagineSfondo.vue?vue&type=script&lang=js&"
export * from "./initImmagineSfondo.vue?vue&type=script&lang=js&"
import style0 from "./initImmagineSfondo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
